import styled from 'styled-components';

interface BaseProps {
	isActive?: boolean;
}

export const Base = styled.button<BaseProps>`
	background: ${({ isActive }) => (isActive ? 'rgba(30, 144, 255, 0.08)' : 'transparent')};
	border: none;
	text-align: left;
	padding: 12px 16px;
	margin-left: 4px;
	margin-right: 4px;
	border-radius: 8px;
	cursor: pointer;
	position: relative;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	min-height: 44px;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 3px;
		height: 100%;
		background: linear-gradient(180deg, #1e90ff 0%, #4169e1 100%);
		opacity: ${({ isActive }) => (isActive ? 1 : 0)};
		transition: opacity 0.2s ease;
		border-radius: 8px 0 0 8px;
	}

	&:hover {
		background-color: ${({ theme, isActive }) =>
			isActive ? 'rgba(30, 144, 255, 0.12)' : theme.gray['200']};
		box-shadow: ${({ isActive }) =>
			isActive ? '0 2px 8px rgba(30, 144, 255, 0.1)' : '0 4px 12px rgba(0, 0, 0, 0.2)'};
	}
`;

export const Title = styled.div<{ isActive?: boolean }>`
	font-size: 14px;
	font-weight: ${({ isActive }) => (isActive ? 500 : 400)};
	color: ${({ theme }) => theme.gray['1000']};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
